import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { H5 } from 'foundations-components/transitional/components/H5';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus';
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
import { View } from 'foundations-components/components/View';
import { LocationIcon } from 'foundations-assets/icons/components/LocationIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const displayName = 'PropertyFormHeader';
const PropertyFormHeader = ({
  userTimezone,
  dateTime,
  location,
  handleGoToPreviousStep
}) => {
  const proposedMeetingDate = dateTime ? I18n.moment(dateTime).tz(userTimezone).format('LLLL') : '';
  return /*#__PURE__*/_jsxs(View, {
    id: "meeting-confirmation-form",
    paddingInline: "800",
    paddingBlockStart: "800",
    "data-timestamp": dateTime,
    "data-selenium-test": "property-form-header",
    children: [/*#__PURE__*/_jsx(HiddenAriaStatus, {
      role: "status",
      "aria-live": "polite",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "accessible.formStatus",
        options: {
          proposedMeetingDate
        }
      })
    }), /*#__PURE__*/_jsx(H4, {
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `prebook.details.yourInfo`
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      align: "baseline",
      justify: "start",
      children: [/*#__PURE__*/_jsx(H5, {
        marginBlockEnd: "0",
        children: proposedMeetingDate
      }), /*#__PURE__*/_jsx(PreviewContext.Consumer, {
        children: isPreview => /*#__PURE__*/_jsx(Link, {
          "aria-label": I18n.text('prebook.details.editLabel'),
          tabIndex: 0,
          onClick: isPreview ? undefined : handleGoToPreviousStep,
          paddingBlockStart: "100",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'prebook.details.edit'
          })
        })
      })]
    }), location && /*#__PURE__*/_jsxs(TFlex, {
      align: "baseline",
      justify: "start",
      children: [/*#__PURE__*/_jsx(View, {
        paddingInlineEnd: "100",
        children: /*#__PURE__*/_jsx(LocationIcon, {
          "aria-label": I18n.text('accessible.meetingLocation')
        })
      }), location]
    })]
  });
};
PropertyFormHeader.displayName = displayName;
export default PropertyFormHeader;